import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import type { FC, ReactNode } from 'react';

/** Long enough that sweeping the pointer across a dense table doesn't flash every hint on the way. */
const HINT_DELAY_MS = 300;

/**
 * Hover help for a pill, tag or control: the explanation too long for the page. The trigger is its own
 * span, so a disabled button or a ref-less tag still opens it.
 */
export const HintTooltip: FC<{ hint: ReactNode; className?: string; children: ReactNode }> = ({
    hint,
    className,
    children,
}) => (
    <Tooltip delayDuration={HINT_DELAY_MS}>
        <TooltipTrigger asChild>
            <span className={cn('inline-flex cursor-help', className)}>{children}</span>
        </TooltipTrigger>
        <TooltipContent className="flex max-w-xs flex-col gap-1.5 text-pretty">{hint}</TooltipContent>
    </Tooltip>
);
